var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.25L11.375 12.125C11.125 11.875 10.875 11.5 10.875 11C10.875 10.125 11.625 9.375 12.5 9.375C12.625 9.375 12.875 9.375 13 9.5C13.875 9.75 14.375 10.625 14.125 11.5C14 12.125 14.25 12.75 14.875 12.875C15.5 13 16.125 12.75 16.25 12.125C16.375 11.75 16.375 11.375 16.375 11C16.375 8.875 14.625 7.125 12.5 7.125C11.5 7.125 10.5 7.5 9.75 8.25C8.25 9.75 8.25 12.25 9.75 13.75L14.875 18.875C15.375 19.375 16 19.375 16.5 18.875C17 18.5 17 17.75 16.5 17.25ZM18.625 5C15.25 1.75 10 1.625 6.625 5C3.25 8.375 3.25 13.75 6.625 17L11.75 22.125C12.25 22.625 12.875 22.625 13.375 22.125C13.875 21.625 13.875 21 13.375 20.5L8.25 15.375C5.875 13 5.875 9 8.25 6.625C10.625 4.25 14.625 4.25 17 6.625C19 8.75 19.25 12.125 17.625 14.5C17.25 15 17.5 15.75 18 16.125C18.5 16.5 19.25 16.25 19.625 15.75C21.75 12.375 21.375 7.875 18.625 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodio);
export default __webpack_public_path__ + "static/media/podio.b6b797ec08460abf4a7f2593bc17fdfa.svg";
export { ForwardRef as ReactComponent };